<template>
  <div class="cpq-settings">
    <div class="container">
      <PageHeader
        title="CPQ Settings"
        description="Configure CPQ settings for this specific form"
      />
      <div class="cpq-settings__card card">
        <CPQConfigurator />
      </div>
    </div>
  </div>
</template>

<script>
  import { ref, computed, onMounted } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { useIntegrationStore } from '@/store/integrationStore';
  import { useFormStore } from '@/store/formStore';
  import { useUIStore } from '@/store/uiStore';
  import PageHeader from '@/components/partials/PageHeader.vue';
  import CPQConfigurator from '@/pages/flow/CPQConfigurator.vue';

  export default {
    name: 'CPQSettingsView',

    components: {
      PageHeader,
      CPQConfigurator,
    },

    setup(props) {
      const route = useRoute();
      const formId = route.params.id;

      return {};
    },
  };
</script>

<style scoped lang="scss">
  @import '@/assets/scss/base/_mixins.scss';
  .cpq-settings {
  }
</style>
